module.exports = __webpack_public_path__ + "img/Play-Button.11ff69fd.svg";